
import './TeamDescription.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TeamDescription = ({title, description, icon}) => {
    return (
        <div className={"team-description"}>
            <h3 className={"team-title"}>{title} &nbsp;
                    <FontAwesomeIcon icon={icon} style={{
                        fontSize: "30px",
                        color: " var(--green-text)"
                    }} />
            </h3>
            <p className={"team-detail-description"}>{description}</p>
        </div>
    );
}

export default TeamDescription;
